/**
 * 数据引导国际化
 * date：2022 07 22
 */
export default {
    analysis: {
        offline_rate: '离线率',
        pass_rate: '通过率',
        data: '数据',
        dataAndChart: '数据+折线图',
        line: '折线图'
    }
};
